import { AllyBase } from './base/ally-base.class';

/**
 * This class can be used to detect and interrupt circular loops caused by listeners.
 * For each callback of a listener a separate AllyCircularLoopProtection object should be used.
 * @extends AllyBase
 */
export class AllyCircularLoopProtection extends AllyBase {
    /**
     * The list of timestamps on which the callback of the listener was executed.
     */
    private counterList: number[];
    private warned: boolean;
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge);
        this.counterList = [];
        this.warned = false;
    }
    /**
     * Checks if the listener is part of a circular loop.
     * This function should be called inside the callback of the listener to be checked.
     * @param nodeId The id of the node the listener is listening on.
     * @param listenerId The id of the listener.
     */
    public checkForCircularLoop(nodeId: string, listenerId: string) {
        this.counterList.push(Date.now());
        let now = Date.now();
        while (this.counterList.length > 0 && now - this.counterList[0] > 10000) {
            this.counterList.splice(0, 1);
        }
        if (this.counterList.length > 1000) {
            if (!this.warned) {
                console.warn('CircularLoop: A foreign listener is likely interfering with this listener(NodeId: ' + nodeId + ', ' + 'ListenerId: ' + listenerId +  '). Use the runOutside function of the AllyService to encapsulate the code of the foreign listener. Inject the AllyService into a class as a property via: "private readonly allyService: IAllyService| null = inject(ALLY_SERVICE, { optional: true });" then use the runOutside function via "this.allyService?.tools.runOutside(() => {});"');
                this.warned = true;
            }
        } else {
            this.warned = false;
        }
    }
}